import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import axios from 'axios';
import { fetchApiAuth } from '../utils/api';
import {
    CompetitionFilters,
    CreateCompetitionRequest,
    UpdateCompetitionRequest,
    CompetitionWinner,
} from './types';

export const getCompetitions = createAsyncThunk(
    'competition/get-competitions',
    async (filters?: CompetitionFilters) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/competition/get-competitions',
                body: filters || {},
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createCompetition = createAsyncThunk(
    'competition/create-competition',
    async (payload: CreateCompetitionRequest) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/competition/create-or-update-competition',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const updateCompetition = createAsyncThunk(
    'competition/update-competition',
    async (payload: UpdateCompetitionRequest) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/competition/create-or-update-competition',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateCompetitionWinner = createAsyncThunk(
    'competition/create-or-update-winner',
    async (payload: Partial<CompetitionWinner> & { id?: number; _method?: string }) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/competition/create-or-update-competition-winner',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const deleteCompetitionWinner = createAsyncThunk(
    'competition/delete-winner',
    async (payload: { winner_id: number }) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/competition/delete-competition-winner',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const getCompetitionReports = createAsyncThunk(
    'competition/get-reports',
    async (payload?: { date_from?: string; date_to?: string; force_refresh?: boolean }) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/competition/get-reports',
                body: payload || {},
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);
